import { useState } from 'react';
import { toast } from 'react-toastify';
import api from '@services/api';
import usePaginationParams from '@hooks/usePaginationParams';
import type { OptionType } from './types';

const useGetList = () => {
  const [dispositionOptions, setDispositionOptions] = useState<OptionType[]>([]);
  const [totalPages, setTotalPages] = useState(0);
  const [loading, setLoading] = useState(true);

  const getDispositionOptions = async ({ page = 1, limit = 10 }) => {
    setLoading(true);
    try {
      const response = await api.get('/disposition_option', {
        params: {
          pageIndex: page,
          pageLimit: limit,
        },
      });
      setDispositionOptions(response.data.data);
      setTotalPages(response.data.total);
    } catch {
      toast.error('Erro ao carregar opções de tabulação. Tente novamente mais tarde.');
    } finally {
      setLoading(false);
    }
  };

  usePaginationParams({ onParamsChange: getDispositionOptions });

  return {
    getDispositionOptions,
    dispositionOptions,
    totalPages,
    loading,
  };
};

export default useGetList;
